/**
 * TOSS Web Application — does a section root draw a back arrow on this surface
 *
 * A screen with a parent always has its arrow: `PageHeader` draws one for `backTo` / `onBack`.
 * A section ROOT — a sidebar entry, the profile, the notifications — has no parent, and whether it
 * still gets an arrow is a property of the SURFACE, not of the screen:
 *
 *  - the internal application: yes (owner, 23.09.2026). Its staff work in a desktop PWA window
 *    that has no browser Back at all, and asked for one beside the title of «Заявки» itself;
 *  - the customer portal: no. On a phone its roots sit behind a bottom navigation, on a computer
 *    behind the sidebar — the tab-root pattern, where a back arrow has nothing to say.
 *
 * So one switch per layout instead of a prop on forty pages: `AppLayout` provides `true`, nothing
 * else provides anything, and the default is `false`. `PageHeader`, the `PageStates` headers and
 * `ScreenToolbar` read it. A screen with its own header reads it the same way or renders
 * `<BackButton />` itself.
 *
 * See `vault/knowledge/decisions/every-titled-screen-draws-a-back-arrow-at-every-width.md`.
 */

import { createContext, useContext } from 'react';

export const RootBackArrowContext = createContext(false);

/** Whether a header with no parent of its own should still draw the history-only arrow. */
export function useRootBackArrow(): boolean {
  return useContext(RootBackArrowContext);
}
